import React from 'react';

import { createStyles, withStyles, Theme, Grid } from '@material-ui/core';

import commonStyles from '../../common/common.module.css';
import styles from '../analytics.module.css';
import Filters from '../../common/AnalyticsFilters';
import AnalyticsFromToDate from '../../common/AnalyticsFromToDate';
import { Moment } from 'moment';
import Tabs from './Tabs';
import Pattern from './Pattern';
import ShipmentData from './ShipmentData';
import { customers, filterOptions } from '../../../models/Analytics';
import AirlineType from '../../../models/AirlineType';

const materialStyles = (theme: Theme) =>
  createStyles({

  });

interface TopCustomersProps {
  classes: any;
  startDate: Moment;
  endDate: Moment;
  pickUp: boolean;
  progress: boolean;
  dropOff: boolean;
  carrCheck: boolean;
  carr: string;
  entity: string;
  rank_by: string;
  tab_id: string;
  intvl: number;
  ship_type: string;
  filterOptions: filterOptions;
  customers: customers[];
  airlines: AirlineType[];
  pattern: any;
  shipmentData: any;
  shipmentCol: any;
  handleChangeDate: (dateType: string, event: any) => void;
  handleChangeProcess: (type: string, value: boolean) => void;
  handleChangeCarriers: (type: string, value: boolean) => void;
  handleChangeOption: (type: string, event: any) => void;
  handleChange: (type: string, event: any) => void;
  handleExport: (type: string) => void;
  exceedHours?: number;
  handleExceedHoursChange: (value: number) => void;
};


const topCustomers = (props: TopCustomersProps) => {

  return (
    <div className={`${commonStyles.mt4} ${commonStyles.positionRelative}`}>
      <AnalyticsFromToDate startDate={props.startDate} endDate={props.endDate} progress={props.progress} handleChangeDate={props.handleChangeDate} />
      <Grid container spacing={4} className={`${styles.customerGridContainer}`}>
        <Grid item className={`${styles.customerGridItemsFilter}`}>
          <Filters
            filterOptions={props.filterOptions}
            airlines={props.airlines}
            pickUp={props.pickUp}
            dropOff={props.dropOff}
            carrCheck={props.carrCheck}
            carr={props.carr}
            entity={props.entity}
            rank_by={props.rank_by}
            handleChangeProcess={props.handleChangeProcess}
            handleChangeCarriers={props.handleChangeCarriers}
            handleChangeOption={props.handleChangeOption}
            handleExceedHoursChange={props.handleExceedHoursChange}
            exceedHours={props.exceedHours}
          />
        </Grid>

        <Grid item className={`${styles.customerGridItemsData} ${styles.topCustomers}`}>
          <div className={`${styles.customerGridItems}`}>
            <Grid container spacing={3} className={`${styles.wtOuterGridContainer}`}>

              <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                <Tabs customers={props.customers} entity={props.entity} rank_by={props.rank_by} tab_id={props.tab_id} handleChange={props.handleChange} handleExport={props.handleExport} />
              </Grid>

              <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                <Pattern pattern={props.pattern} intvl={props.intvl} handleChange={props.handleChange} handleExport={props.handleExport} />
              </Grid>

              <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                <ShipmentData shipmentCol={props.shipmentCol} shipmentData={props.shipmentData} ship_type={props.ship_type} handleChange={props.handleChange} handleExport={props.handleExport} />
              </Grid>

            </Grid>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default withStyles(materialStyles)(topCustomers);
